import { useState } from 'react';
import styled from 'styled-components';

const SwitchDeviceLogs = ({ logs }) => {
  const [expanded, setExpanded] = useState(false);

  const sampleLogs = logs || [
    { timestamp: '2026-03-08 14:32', message: "Program 'Snow Sensor' parameters", status: 'SUCCESS' },
    { timestamp: '2026-03-08 14:30', message: "Program 'Snow Sensor' parameters", status: 'SUCCESS' },
    { timestamp: '2026-03-08 14:28', message: "Program 'Snow Sensor' parameters", status: 'SUCCESS' },
  ];

  return (
    <Section>
      <SectionHeader>
        <HeaderLeft>
          <GearSvg viewBox="0 0 16 16" fill="none">
            <path d="M6.86 1.45a1.2 1.2 0 0 1 2.28 0l.2.6a1.2 1.2 0 0 0 1.61.72l.58-.26a1.2 1.2 0 0 1 1.61 1.61l-.26.58a1.2 1.2 0 0 0 .72 1.61l.6.2a1.2 1.2 0 0 1 0 2.28l-.6.2a1.2 1.2 0 0 0-.72 1.61l.26.58a1.2 1.2 0 0 1-1.61 1.61l-.58-.26a1.2 1.2 0 0 0-1.61.72l-.2.6a1.2 1.2 0 0 1-2.28 0l-.2-.6a1.2 1.2 0 0 0-1.61-.72l-.58.26a1.2 1.2 0 0 1-1.61-1.61l.26-.58a1.2 1.2 0 0 0-.72-1.61l-.6-.2a1.2 1.2 0 0 1 0-2.28l.6-.2A1.2 1.2 0 0 0 2.86 4.7l-.26-.58a1.2 1.2 0 0 1 1.61-1.61l.58.26a1.2 1.2 0 0 0 1.61-.72l.2-.6ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="currentColor" />
          </GearSvg>
          <HeaderTitle>DEVICE CONFIGURATION LOGS</HeaderTitle>
        </HeaderLeft>
        <ExpandBtn onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Close' : 'Expand'}
        </ExpandBtn>
      </SectionHeader>

      {expanded && (
        <LogsList>
          {sampleLogs.map((log, i) => (
            <LogEntry key={i}>
              <LogTimestamp>{log.timestamp}</LogTimestamp>
              <LogMessage>{log.message}</LogMessage>
              <LogBadge $status={log.status}>{log.status}</LogBadge>
            </LogEntry>
          ))}
        </LogsList>
      )}
    </Section>
  );
};

export default SwitchDeviceLogs;

const Section = styled.div`
  margin: 0 20px;
  background: var(--switch-panel-bg-soft);
  border: 0.8px solid var(--switch-border);
  border-radius: 16px;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const GearSvg = styled.svg`
  width: 15px;
  height: 15px;
  color: var(--switch-text-faint);
`;

const HeaderTitle = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: var(--switch-text-muted);
`;

const ExpandBtn = styled.button`
  padding: 6px 16px;
  border-radius: 10px;
  border: 0.8px solid var(--switch-border);
  background: var(--switch-button-bg);
  color: var(--switch-text-muted);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: var(--switch-shadow-soft);

  &:hover {
    color: var(--switch-text-primary);
    border-color: rgba(59, 130, 246, 0.4);
  }
`;

const LogsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 20px 20px;
`;

const LogEntry = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: var(--switch-input-bg);
  border: 0.8px solid var(--switch-border);
  border-radius: 14px;
`;

const LogTimestamp = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  color: var(--switch-text-faint);
  white-space: nowrap;
  min-width: 110px;
`;

const LogMessage = styled.span`
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: var(--switch-text-secondary);
`;

const LogBadge = styled.span`
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${({ $status }) => ($status === 'SUCCESS' ? '#00D492' : '#EE4B56')};
  background: ${({ $status }) => ($status === 'SUCCESS' ? 'rgba(0, 188, 125, 0.1)' : 'rgba(238, 75, 86, 0.1)')};
`;
